import { mdiNoteEdit, mdiNoteEditOutline } from '@mdi/js'
import Icon from '@mdi/react'

const NotesIcon = (props) => {
    const { filled, ...other } = props
    return (
        <Icon
            path={filled ? mdiNoteEdit : mdiNoteEditOutline}
            data-testid="ModelTile__HasNote"
            size={1}
            {...other}
        />
    )
}

export default NotesIcon
export { NotesIcon }
